var _defs, _defs2, _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTribeAtomic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ALL_LOGOS",
    "data-name": "ALL LOGOS",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 609.82l-58.89-102.01-58.89-102h235.56l-58.89 102L500 609.82z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 611.84l-119.53-207h239.06zm-116-205l116 201 116-201z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.22 813.82l-58.89-102-58.89-102H500l-58.89 102-58.89 102z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.22 815.84l-119.53-207h239.06zm-116-205l116 201 116-201z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.78 813.82l-58.89-102-58.89-102h235.57l-58.9 102-58.89 102z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.78 815.84l-119.53-207h239.06zm-116-205l116 201 116-201z",
    className: "cls-2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M865.46 807.1l-359-621.74c-.08-.12-.17-.22-.25-.34a6.17 6.17 0 00-.48-.66c-.15-.19-.32-.36-.49-.54s-.34-.33-.53-.48a6.38 6.38 0 00-.67-.49c-.12-.07-.21-.17-.33-.24s-.15-.05-.22-.09a7.43 7.43 0 00-.76-.35c-.21-.08-.42-.17-.63-.23s-.48-.12-.73-.17-.46-.09-.7-.11a6 6 0 00-.74 0 5.3 5.3 0 00-.69 0 6 6 0 00-.74.12 7 7 0 00-.69.16 5.84 5.84 0 00-.66.24 6.89 6.89 0 00-.73.34 1.45 1.45 0 00-.22.09c-.13.08-.22.17-.34.25a6.29 6.29 0 00-.67.48 7.22 7.22 0 00-1.5 1.68c-.08.12-.17.22-.24.34l-359 621.74a7.5 7.5 0 006.5 11.26H859a7.5 7.5 0 006.5-11.26zm-351-203.28a15.68 15.68 0 00-29 0H269.24L500 204.14l230.76 399.68zm-253.92 15h226.65a15.65 15.65 0 0025.62 0h226.62l113 195.77q.24.39.51.75H147q.27-.36.51-.75z",
    className: "cls-2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTribeAtomic);
export default __webpack_public_path__ + "static/media/Tribe_Atomic.376e1eee.svg";
export { ForwardRef as ReactComponent };